var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3139",
    "data-name": "Rectangle 3139",
    width: 25,
    height: 26,
    transform: "translate(-2 -2)",
    fill: "#2e728c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11044",
    "data-name": "Group 11044",
    transform: "translate(1.5 2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11043",
    "data-name": "Group 11043",
    transform: "translate(0.5 -0.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28987",
    "data-name": "Path 28987",
    d: "M18.261,0H3.222A3.224,3.224,0,0,0,0,3.222V13.964a3.224,3.224,0,0,0,3.222,3.222H15.67l3.979,3.983a1.072,1.072,0,0,0,.761.314.936.936,0,0,0,.408-.085,1.07,1.07,0,0,0,.666-.99V3.222A3.224,3.224,0,0,0,18.261,0m1.074,17.818-2.462-2.466a1.072,1.072,0,0,0-.761-.314H3.222a1.075,1.075,0,0,1-1.074-1.074V3.222A1.075,1.075,0,0,1,3.222,2.148H18.261a1.075,1.075,0,0,1,1.074,1.074Z",
    transform: "translate(-0.477 0.477)",
    fill: "#2e728c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.35b53192f860060849c979a1bf2880ff.svg";
export { ForwardRef as ReactComponent };